import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';
import { all } from 'redux-saga/effects';
import { combineReducers } from "redux";
import { createBrowserHistory } from 'history';
import { configureStore } from '@reduxjs/toolkit';
import { createReduxHistoryContext } from 'redux-first-history';
import { persistReducer, persistStore } from 'redux-persist';

import authReducer, { AuthState } from './auth/slice';
import { watchAuthSaga } from './auth/saga';

import vehiclesReducer, { VehicleState } from './vehicles/slice';
import { watchVehiclesSaga } from './vehicles/saga';

import partsReducer, { PartState } from './parts/slice';
import { watchPartsSaga } from './parts/saga';

import employeeReducer, { EmployeeState } from './employee/slice';
import { watchEmployeeSaga } from './employee/saga';

import statsReducer, { StatState } from './stats/slice';
import { watchStatsSaga } from './stats/saga';

import tasksReducer, { TaskState } from './tasks/slice';
import { watchTasksSaga } from './tasks/saga';

const {
    createReduxHistory,
    routerMiddleware,
    routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory() });

const sagaMiddleware = createSagaMiddleware();

// Setup Redux persist
const persistAuthConfig = {
    key: 'auth',
    blacklist: ['error', 'loading'],
    storage,
};
const persistVehiclesConfig = {
    key: 'vehicle',
    blacklist: ['error', 'loading'],
    storage,
};
const persistPartsConfig = {
    key: 'parts',
    blacklist: ['error', 'loading'],
    storage,
};
const persistStatsConfig = {
    key: 'stats',
    blacklist: ['error', 'loading'],
    storage,
};
const persistTasksConfig = {
    key: 'tasks',
    blacklist: ['error', 'loading'],
    storage,
};
const persistEmployeeConfig = {
    key: 'employee',
    blacklist: ['error', 'loading'],
    storage,
};

const persistedAuthReducer = persistReducer(persistAuthConfig, authReducer);
const persistedVehiclesReducer = persistReducer(persistVehiclesConfig, vehiclesReducer);
const persistedPartsReducer = persistReducer(persistPartsConfig, partsReducer);
const persistedStatsReducer = persistReducer(persistStatsConfig, statsReducer);
const persistedTasksReducer = persistReducer(persistTasksConfig, tasksReducer);
const persistedEmployeeReducer = persistReducer(persistEmployeeConfig, employeeReducer);

export const store = configureStore({
    reducer: combineReducers({
        auth: persistedAuthReducer,
        vehicles: persistedVehiclesReducer,
        parts: persistedPartsReducer,
        stats: persistedStatsReducer,
        tasks: persistedTasksReducer,
        employees: persistedEmployeeReducer,
        router: routerReducer,
    }),
    middleware: (getDefaultMiddleware: (arg0: { serializableCheck: boolean; }) => any[]) => getDefaultMiddleware({
        serializableCheck: false
    }).concat(routerMiddleware).concat(sagaMiddleware),
});
export const history = createReduxHistory(store);
export const persistor = persistStore(store);
export interface RootState {
    vehicles: VehicleState;
    parts: PartState;
    stats: StatState;
    auth: AuthState;
    tasks: TaskState;
    employees: EmployeeState;
}

function* rootSaga() {
    yield all([
        watchAuthSaga(),
        watchVehiclesSaga(),
        watchPartsSaga(),
        watchTasksSaga(),
        watchStatsSaga(),
        watchEmployeeSaga(),
    ]);
}

sagaMiddleware.run(rootSaga);
